import { Directive, ElementRef, EventEmitter, Input, Output, HostListener } from '@angular/core';
import { NgModel } from '@angular/forms';
import { environment } from '@environment/environment';
import { UrlService } from '@service/url/url.service';
import { CustomRestService } from '@service/customRest/custom-rest.service';
import { UtilService } from '@service/util/util.service';

declare var google: any;

@Directive({
	selector: '[appGoogleLocation]',
})
export class GoogleLocationDirective {
	@Input() allowStateSelection: boolean = false;
	@Output() setAddress: EventEmitter<any> = new EventEmitter();
	modelValue: any;
	autocomplete: any;
	private _el: HTMLInputElement;

	constructor(
		el: ElementRef,
		private model: NgModel,
		private urlService: UrlService,
		private googleService: CustomRestService,
		private utilService: UtilService
	) {
		this._el = el.nativeElement;
		this.modelValue = this.model;
		let input = this._el;

		const options = {
			types: ['(regions)'],
			componentRestrictions: { country: environment.TRUCK_SEARCH_COUNTRY },
		};
		this.autocomplete = new google.maps.places.Autocomplete(input, options);
		google.maps.event.addListener(this.autocomplete, 'place_changed', () => {
			if (this.utilService.isNullOrUndefined(this.autocomplete.getPlace().address_components)) {
				this.onEnterKeySelectTopResult();
			} else {
				this.invokeEvent(this.autocomplete.getPlace());
			}
		});
		input.addEventListener('input', (event) => {
			if (!event['target']['value']) {
				this.setAddress.emit({
					latitude: '',
					longitude: '',
					city: '',
					state: '',
					country: '',
					zip: '',
					timezone: '',
				});
			}
		});
	}

	invokeEvent(place: Object) {
		let location = { zip: null },
			sublocation = false;
		if (place['geometry']) {
			location['latitude'] = place['geometry'].location.lat();
			location['longitude'] = place['geometry'].location.lng();
		}
		if (place['address_components']?.length) {
			place['address_components'].map((address_components) => {
				const localityCheck = address_components.types.indexOf('locality');
				const sublocalityLevelCheck = address_components.types.indexOf('sublocality_level_1');
				const neighborhoodCheck = address_components.types.indexOf('neighborhood');
				if (neighborhoodCheck !== -1) {
					location['city'] = address_components.long_name;
					sublocation = true;
				} else if (sublocalityLevelCheck !== -1 && !sublocation) {
					location['city'] = address_components.long_name;
					sublocation = true;
				} else if (localityCheck !== -1 && !sublocation) {
					location['city'] = address_components.long_name;
				}
				const stateCheck = address_components.types.indexOf('administrative_area_level_1');
				if (stateCheck !== -1) {
					location['state'] = address_components.short_name;
				}
				const countryCheck = address_components.types.indexOf('country');
				if (countryCheck !== -1) {
					location['country'] = address_components.short_name;
				}
				const postalCodeCheck = address_components.types.indexOf('postal_code');
				if (postalCodeCheck !== -1) {
					location.zip = address_components.long_name;
				}
			});

			const isNotState = !this.isStateSelected(place);
			// check to see if display value and selected value are same for the same state
			if (isNotState && this._el?.value?.length) {
				const inputLocation = this._el.value.split(',');
				const city = inputLocation[0],
					state = inputLocation[1].trim();
				if (city !== location['city'] && state === location['state']) {
					const inputCity = place['address_components']?.find(
						(addressComponent) => addressComponent.long_name === city
					);
					if (inputCity?.long_name) {
						location['city'] = inputCity.long_name;
					}
				}
			}
			if (isNotState) {
				location['state_full_form'] = place['address_components'][2].long_name;
			}

			if (this.utilService.isNullOrUndefined(location.zip)) {
				if (isNotState) {
					const geocoder = new google.maps.Geocoder(),
						vm = this;
					const latLng = new google.maps.LatLng(
						place['geometry'].location.lat(),
						place['geometry'].location.lng()
					);

					geocoder.geocode({ location: latLng }, function (results, status) {
						if (status == google.maps.GeocoderStatus.OK) {
							for (
								var res = 0;
								res < results.length && vm.utilService.isNullOrUndefined(location.zip);
								res++
							) {
								for (var i = 0; i < results[res].address_components.length; i++) {
									const postalCodeCheck =
										results[res].address_components[i].types.indexOf('postal_code');
									if (postalCodeCheck !== -1) {
										location.zip = results[res].address_components[i].long_name;
									}
								}
							}
						}
						vm.getTimeZone(
							place['geometry'].location.lat() + ',' + place['geometry'].location.lng(),
							location
						);
					});
				} else if (this.allowStateSelection) {
					this.getTimeZone(
						place['geometry'].location.lat() + ',' + place['geometry'].location.lng(),
						location,
						isNotState
					);
				}
			} else {
				this.getTimeZone(
					place['geometry'].location.lat() + ',' + place['geometry'].location.lng(),
					location
				);
			}
		}
	}

	getTimeZone(latLng: any, location: any, isNotState: boolean = true) {
		const url = this.urlService.getTimezone(latLng);
		this.googleService.GET(url).subscribe(
			(result) => {
				location['timezone'] = result.timeZoneId;
				if (
					isNotState &&
					this.utilService.isNullOrUndefined(location.city) &&
					!this.utilService.isNullOrUndefined(this._el.value.split(',')[0])
				) {
					location.city = this._el.value.split(',')[0];
				}
				const isAState = !isNotState;
				if (isAState) {
					location['latitude'] = null;
					location['longitude'] = null;
				}
				this.model.model = location;
				this.setAddress.emit(location);
			},
			(error) => {
				this.model.model = location;
				this.setAddress.emit(location);
				console.log('error in fething location timezone: ', error);
			}
		);
	}

	onEnterKeySelectTopResult(): any {
		var service = new google.maps.places.AutocompleteService();
		service.getPlacePredictions(
			{
				input: this.model.value,
				types: ['(regions)'],
				componentRestrictions: { country: environment.TRUCK_SEARCH_COUNTRY },
			},
			(data) => {
				if (
					!this.utilService.isNullOrUndefined(data) &&
					!this.utilService.isNullOrUndefined(data[0])
				) {
					this._el.value = data[0].description;
					this.getPlaceFromPlaceId(data[0].place_id);
				}
			}
		);
	}

	getPlaceFromPlaceId(placeId): any {
		var placeService = new google.maps.places.PlacesService(document.createElement('div'));
		placeService.getDetails({ placeId: placeId }, (placeResult, status) => {
			if (status === 'OK') {
				this.invokeEvent(placeResult);
			}
		});
	}

	isStateSelected(place: Object): boolean {
		return (
			place['address_components'] &&
			place['address_components'].length == 2 &&
			place['address_components'][0]['types'].includes('administrative_area_level_1') &&
			place['address_components'][1]['types'].includes('country')
		);
	}

	@HostListener('blur') onBlur() {
		setTimeout(() => {
			const location = this._el.value?.split(',')?.length;
			if (!location || location === 1) {
				this._el.value = '';
				this.setAddress.emit({
					latitude: '',
					longitude: '',
					city: '',
					state: '',
					country: '',
					zip: '',
					timezone: '',
				});
			}
		}, 200);
	}
}
